
    import __i18nConfig from '@next-translate-root/i18n.js'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { NextSeo } from "@components/seo";
import { getAllPostsPaths, getPostByslug } from "@utils/get-posts";
import parse from "html-react-parser";
import type { GetStaticPaths, GetStaticProps } from "next";
import dynamic from "next/dynamic";
import Image from "next/image";
import { ArticleJsonLd } from "next-seo";
const React360Viewer = dynamic(() => import("react-360-product-viewer").then((m) => m.React360Viewer), { ssr: false });
import type { TPost, TPostPath } from "../../types/posts";
type IPost = TPost & {
    modified: string;
};
const News = (props: {
    post: IPost;
}) => {
    const { post } = props;
    const desc = post.content.replace(/(<([^>]+)>)/gi, "");
    const trimmedString = desc.slice(0, 250);
    const postDescription = `${trimmedString.slice(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(" ")))} ...`;
    const postContentVideoFix = post.content.replace(/width: 1920px;/gi, "width: 100% !important; ");
    return (<>
      <NextSeo title={`${post?.title} - KNS Okna`}/>
      <ArticleJsonLd author={[{ name: "KNS Okna" }]} dateModified={post.modified} datePublished={post.date} description={postDescription} headline={`${post?.title} - KNS Okna`} image={[post.featuredImage.node.sourceUrl]} publisher={{ name: "KNS Okna" }} url={`https://knsokna.pl/news/${post.slug}`}/>
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8 lg:py-8">
        <div className="text-center">
          <Image alt={post?.title} className="m-auto" height={630} src={post.featuredImage?.node.sourceUrl} width={1200}/>
        </div>
        <h1 className="text-4xl">{post?.title}</h1>
        <hr />
        {(post.slug === "veka-aluconnect" || post.slug === "aluconnect") && (<div style={{ textAlign: "center" }}>
            <React360Viewer imageFilenamePrefix={""} imagesBaseUrl="/360/pvc/veka/AluConnect/" imagesCount={37} imagesFiletype="png" mouseDragSpeed={20} width={640}/>
          </div>)}
        <div>{parse(postContentVideoFix || "")}</div>
      </div>
    </>);
};
export const getStaticPaths: GetStaticPaths = async (_context) => {
    const { paths: path } = await getAllPostsPaths();
    const paths = path.map((p: TPostPath) => ({
        locale: p.language.slug.toLowerCase(),
        params: {
            slug: `${p.slug}`,
        },
    }));
    return { fallback: "blocking", paths };
};
const getStaticProps: GetStaticProps = async (context) => {
    const slug = context.params?.slug as string;
    const locale = context.locale ?? "pl";
    const LOCALE = locale === "cz" ? "CS" : locale.toUpperCase();
    const { postData } = await getPostByslug(slug, LOCALE);
    const post = postData?.post;
    if (!post) {
        return {
            notFound: true,
        };
    }
    return {
        props: {
            post,
        },
    };
};
export default News;

    async function __Next_Translate__getStaticProps__1a19cd2bf00__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/news/[slug]',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a19cd2bf00__ as getStaticProps }
  